import React, {Component} from 'react';
import PropTypes from "prop-types";

class Fieldset extends Component {
    static propTypes = {
        formState: PropTypes.object.isRequired,
        fieldName: PropTypes.string.isRequired,
        className: PropTypes.string,
        children: PropTypes.node.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {formState, fieldName, className, children, ...props} = this.props;
        const hasError = formState[fieldName] ? 'has-error has-validation-error' : '';
        return (
            <fieldset className={`form-group ${className} ${hasError}`} {...props}>
                {children}
                {
                    formState[fieldName] &&
                    <div className="form-message validation-error">
                        {formState[fieldName]}
                    </div>
                }
            </fieldset>
        );
    }
}

export default Fieldset;


// WEBPACK FOOTER //
// ./src/utils/components/Fieldset.js